export default "__VITE_ASSET__Bqbqt8on__"